export const pattern = [
  'Nexen N’Fera RU1',
  'Nexen N’Fera RU5',
  'Nexen N’Fera SU1',
  'Nexen N’Blue HD PLUS',
  'Nexen N’Fera SUR4G',
  'Nexen N’Priz RH7',
  'Nexen Pro RA8',
  'Nexen RO-GTX',
  'Nexen RO-HP',
  'Nexen Roadian CT8',
  'Nexen ROHTX RH5',
]
